export interface KriteriaAuditKebersihanAlat {
  no: number;
  no_label: string;
  kelompok: string | null;
  kriteria: string;
  dasar_regulasi: string;
}

// 13 item blanko "AUDIT KEBERSIHAN ALAT KESEHATAN" (Komite PPI RSPS).
// Item 1-2 = umum; item 3-13 = sub a–k grup "Pembersihan Alat Keperawatan".
// Single source of truth backend: App\AuditKebersihanAlatSession::KRITERIA
export const KELOMPOK_ALKEP = "Pembersihan Alat Keperawatan";

export const KRITERIA_AUDIT_KEBERSIHAN_ALAT: KriteriaAuditKebersihanAlat[] = [
  {
    no: 1,
    no_label: "1",
    kelompok: null,
    kriteria:
      "Alat kesehatan / keperawatan bersih tidak berkarat (kursi roda, brankar, troli, standar infus, syringe pump, infusion pump, tabung oksigen, humidifier, pispot, urinal)",
    dasar_regulasi: "Permenkes 27/2017 (PPI); Permenkes 7/2019 (Kesling RS)"
  },
  {
    no: 2,
    no_label: "2",
    kelompok: null,
    kriteria: "Ada jadwal dan bukti pembersihan alat-alat tersebut",
    dasar_regulasi: "Permenkes 27/2017 (monitoring & evaluasi PPI)"
  },
  {
    no: 3,
    no_label: "a",
    kelompok: KELOMPOK_ALKEP,
    kriteria: "Stetoskop didesinfeksi alkohol 70% antar pasien",
    dasar_regulasi:
      "Permenkes 27/2017 (dekontaminasi alat non-kritikal); Spaulding/CDC"
  },
  {
    no: 4,
    no_label: "b",
    kelompok: KELOMPOK_ALKEP,
    kriteria:
      "Manset tensimeter dicuci 1 kali seminggu atau bila terkena darah / cairan tubuh pasien",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi alat non-kritikal)"
  },
  {
    no: 5,
    no_label: "c",
    kelompok: KELOMPOK_ALKEP,
    kriteria: "Ambubag dilakukan DTT / steril setiap ganti pasien",
    dasar_regulasi:
      "Permenkes 27/2017 (alat semikritikal — DTT/steril); Spaulding"
  },
  {
    no: 6,
    no_label: "d",
    kelompok: KELOMPOK_ALKEP,
    kriteria: "Thermometer diusap alkohol 70% setiap ganti pasien",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi alat non-kritikal)"
  },
  {
    no: 7,
    no_label: "e",
    kelompok: KELOMPOK_ALKEP,
    kriteria: "Syringe pump diusap alkohol 70% setiap ganti pasien",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi permukaan alat)"
  },
  {
    no: 8,
    no_label: "f",
    kelompok: KELOMPOK_ALKEP,
    kriteria: "EKG: chest electrode diusap alkohol 70% setiap ganti pasien",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi permukaan alat)"
  },
  {
    no: 9,
    no_label: "g",
    kelompok: KELOMPOK_ALKEP,
    kriteria:
      "Kursi roda diusap dengan chlorine 0,05% setiap habis digunakan",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi permukaan alat)"
  },
  {
    no: 10,
    no_label: "h",
    kelompok: KELOMPOK_ALKEP,
    kriteria: "Brankar diusap dengan chlorine 0,05% setiap habis digunakan",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi permukaan alat)"
  },
  {
    no: 11,
    no_label: "i",
    kelompok: KELOMPOK_ALKEP,
    kriteria:
      "Tabung oksigen diusap dengan chlorine 0,05% setiap habis digunakan",
    dasar_regulasi: "Permenkes 27/2017 (dekontaminasi permukaan alat)"
  },
  {
    no: 12,
    no_label: "j",
    kelompok: KELOMPOK_ALKEP,
    kriteria: "Pispot dibersihkan dengan rendam khlorin 0,5%",
    dasar_regulasi:
      "Permenkes 27/2017 (dekontaminasi alat terkontaminasi cairan tubuh)"
  },
  {
    no: 13,
    no_label: "k",
    kelompok: KELOMPOK_ALKEP,
    kriteria:
      "Korden dibersihkan minimal 1 bulan sekali / apabila terkena kontaminan",
    dasar_regulasi: "Permenkes 7/2019 (Kesling RS); Permenkes 27/2017"
  }
];

export const KAK_ITEM_COUNT = KRITERIA_AUDIT_KEBERSIHAN_ALAT.length;

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const PENILAIAN_OPTIONS = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check-bold" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close-thick" },
  { text: "N/A", value: "na", color: "grey", icon: "mdi-minus" }
];
